/** A rank's label: admin display name, else its code. */
export function rankDisplayName(rank: { code: string; name: string | null }): string {
  return rank.name?.trim() || rank.code;
}
